module.exports = __webpack_public_path__ + "static/media/OptionsGrey.0ccf1845.svg";